<mat-form-field class="example-chip-list" appearance="fill">
  <mat-label>{{ label }}</mat-label>
  <mat-chip-grid #chipGrid [ariaLabel]="label" class="mb-2">
    <mat-chip-row *ngFor="let chip of chips" color="primary" [highlighted]="true" (removed)="removeChip(chip)" [disabled]="disabled">
      <img matChipAvatar *ngIf="chip.image" [src]="chip.image | secureImg" [alt]="chip.title" />
      {{ chip[displayProperty] }}
      <button matChipRemove [attr.aria-label]="'remove ' + chip[displayProperty]">
        <mat-icon>cancel</mat-icon>
      </button>
    </mat-chip-row>
  </mat-chip-grid>
  <input
    [placeholder]="placeholder"
    #searchInput
    [formControl]="searchInputControl"
    [matChipInputFor]="chipGrid"
    [matAutocomplete]="auto"
    [matAutocompleteDisabled]="disabled"
    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
  />
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectedFromAutocomplete($event)" [autoActiveFirstOption]="true">
    <mat-option *ngFor="let suggestion of suggestions$ | async" [value]="suggestion">
      <div class="flex flex-col">
        <span class="text-xs" *ngIf="optionLabelPredicate">{{ optionLabelPredicate(suggestion) }}</span>
        <span>{{ suggestion[displayProperty] }}</span>
      </div>
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
